import axios from "axios";

const getLatLong = async (cep, street, city, district, state) => {
  try {
    const result = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${cep}+${street}+${city}+${district}+${state}&key=AIzaSyAUTE8yFC_U0BQ0Rd96JUtW9EfCaZYyPxE`,
    );

    let lat = result ? result.data.results[0].geometry.location.lat : null;
    let long = result ? result.data.results[0].geometry.location.lng : null;

    return { lat, long };
  } catch (e) {
    console.error("Erro ao obter lat/long:", e);
    return {
      lat: null,
      long: null,
    };
  }
};

export default getLatLong;
